import { render, staticRenderFns } from "./PanelBed.vue?vue&type=template&id=db161d80&scoped=true"
import script from "./PanelBed.vue?vue&type=script&lang=js"
export * from "./PanelBed.vue?vue&type=script&lang=js"
import style0 from "./PanelBed.vue?vue&type=style&index=0&id=db161d80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db161d80",
  null
  
)

export default component.exports